export const PRINT_BORDER = '1px solid #111';

export const PRINT_CUT_GUIDE_BORDER = '1px dashed #888';

export const PRINT_FONT_FAMILY = 'Arial, Helvetica, sans-serif';

export const PRINT_BRAND_FONT_FAMILY =
  '"Optima Pro", Optima, Candara, "Segoe UI", sans-serif';

export const PRINT_COLOR_ADJUST = {
  printColorAdjust: 'exact',
  WebkitPrintColorAdjust: 'exact',
} as const;

const PRINT_DARK_BG = '#111';

export const PRINT_DARK_DIVIDER = '1px solid rgba(255, 255, 255, 0.35)';

const PRINT_SECTION_BG = '#e8e8e8';

export const PRINT_LABEL_BG = '#f7f7f7';

export const PRINT_PADDING_X = 1;

const PRINT_PADDING_Y = 0.5;

export const PRINT_IMAGE_COLUMN_WIDTH = 300;

export const PRINT_REMARKS_HEIGHT = 72;

export const PRINT_REMARKS_MAX_LINES = 3;

export const PRINT_FIELD_ROW_GAP = 1;

export const PRINT_SIZE_FIELDS_PER_ROW = 4;

export const PRINT_FONT_SIZE = {
  label: 12,
  remarks: 12,
  headerLabel: 14,
  value: 16,
  measurement: 18,
  summary: 20,
  headerDate: 22,
  headerTitle: 26,
  headerQuantity: 28,
} as const;

export const cellPaddingSx = {
  px: PRINT_PADDING_X,
  py: PRINT_PADDING_Y,
} as const;

export const labelTypographySx = {
  fontSize: PRINT_FONT_SIZE.label,
  fontWeight: 700,
  letterSpacing: 0.5,
  lineHeight: 1.1,
  textTransform: 'uppercase',
} as const;

export const mutedLabelTypographySx = {
  ...labelTypographySx,
  color: 'text.secondary',
} as const;

export const valueTypographySx = {
  fontSize: PRINT_FONT_SIZE.value,
  fontWeight: 700,
  lineHeight: 1.15,
  textTransform: 'uppercase',
} as const;

export const darkCellSx = {
  bgcolor: PRINT_DARK_BG,
  color: '#fff',
  ...PRINT_COLOR_ADJUST,
} as const;

export const sectionBarSx = {
  ...cellPaddingSx,
  bgcolor: PRINT_SECTION_BG,
  borderBottom: PRINT_BORDER,
  ...PRINT_COLOR_ADJUST,
} as const;
